import HttpClient from "../utils/http-client";

export class ProgramsService extends HttpClient {
  async getAllPrograms() {
    return await this.http.get(`/courses/programs`);
  }

  async getProgramMetadata(programId) {
    return await this.http.get(`/courses/programs/${programId}`);
  }

  async getCoursesByOrgCode(code) {
    return await this.http.get(`/organization/${code}/courses`);
  }

  async getCourseDetails(courseId, params = {}) {
    return this.http.get(`/courses/course/${courseId}`, { params });
  }

  async getCourseCredentials(courseId) {
    const apiUrl = `courses/credential/${courseId}`;
    return this.http.get(apiUrl);
  }

  async sendProgramInfo(programData) {
    const apiUrl = `/courses/course`;
    return this.http.post(apiUrl, programData);
  }

  async updateCourseMetadata(body) {
    const apiUrl = `courses/course/metadata`;
    return this.http.put(apiUrl, body);
  }

  async getAllCredentials() {
    const apiUrl = `courses/credentials`;
    return this.http.get(apiUrl);
  }

  async getAllActivities(get_details = false) {
    const apiUrl = `courses/activities?get_details=${get_details}`;
    return this.http.get(apiUrl);
  }

  async deleteCourseTemplate(courseId) {
    const apiUrl = `courses/course/${courseId}`;
    return this.http.delete(apiUrl);
  }

  async deleteUnit(unitId, programId) {
    const apiUrl = `courses/${programId}/unit/${unitId}`;
    return this.http.delete(apiUrl);
  }

  async deleteLesson(lessonId, programId) {
    const apiUrl = `courses/${programId}/lesson/${lessonId}`;
    return this.http.delete(apiUrl);
  }

  async getAllCourseActivities(courseId) {
    const apiUrl = `courses/activities/course/${courseId}`;
    return this.http.get(apiUrl);
  }

  async getProgramActivityLogs(programId) {
    const apiUrl = `/client-services/templates/programs/${programId}/activity-log`;
    return this.http.get(apiUrl);
  }
}
